"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalEntity = void 0;
var LegalEntity;
(function (LegalEntity) {
    LegalEntity["SOLE_PROPRIETORSHIP"] = "sole_proprietorship";
    LegalEntity["ORGANISATION"] = "organisation";
    LegalEntity["PARTNERSHIP_UNDER_FIRM"] = "partnership_under_firm";
    LegalEntity["PRIVATE_COMPANY"] = "private_company";
    LegalEntity["LIMITED_COMPANY"] = "limited_company";
    LegalEntity["UNION"] = "union";
    LegalEntity["FOUNDATION"] = "foundation";
    LegalEntity["COOPERATION"] = "cooperation";
    LegalEntity["LIMITED_PARTNERSHIP"] = "limited_partnership";
})(LegalEntity = exports.LegalEntity || (exports.LegalEntity = {}));
